import React, { useState, useRef, useCallback } from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Button,
  ButtonGroup,
  CustomInput,
  Row,
  Col,
} from 'reactstrap';
import Header from 'components/Headers/Header';
import AccessRestriction from 'components/AccessRestriction/AccessRestriction';
import TrialBanner from 'components/Trial/TrialBanner';
import BoardsCountdownBanner from 'components/Trial/BoardsCountdownBanner';
import MuscleMode from 'components/QuestionBank/MuscleInnervation/MuscleMode';
import NerveMode from 'components/QuestionBank/MuscleInnervation/NerveMode';
import Scoreboard from 'components/QuestionBank/MuscleInnervation/Scoreboard';

const MuscleInnervationDrills = () => {
  const [mode, setMode] = useState('muscle');
  const [showNerve, setShowNerve] = useState(true);
  const [showRoot, setShowRoot] = useState(true);
  const [showFn, setShowFn] = useState(true);

  const muscleModeRef = useRef(null);
  const nerveModeRef = useRef(null);

  const [muscleScore, setMuscleScore] = useState({
    nerve: 0, nerveTotal: 0, root: 0, rootTotal: 0, fn: 0, fnTotal: 0
  });
  const [nerveScore, setNerveScore] = useState({
    musclesRecalled: 0, musclesTotal: 0, nervesComplete: 0, nervesTotal: 0
  });

  const handleMuscleScoreChange = useCallback(score => setMuscleScore(score), []);
  const handleNerveScoreChange = useCallback(score => setNerveScore(score), []);

  const activeRef = mode === 'muscle' ? muscleModeRef : nerveModeRef;

  const handleCheckAll = () => {
    if (activeRef.current) activeRef.current.checkAll();
  };
  const handleRevealAll = () => {
    if (activeRef.current) activeRef.current.revealAll();
  };
  const handleReset = () => {
    if (activeRef.current) activeRef.current.resetAll();
  };
  const handlePrint = () => {
    window.print();
  };

  return (
    <>
      <Header />
      <AccessRestriction>
        <div className="container-fluid mt--7">
          <TrialBanner />
          <BoardsCountdownBanner />
          <Card className="shadow">
            <CardHeader className="border-0">
              <Row className="align-items-center">
                <Col xs="12" lg="auto" className="mb-2 mb-lg-0">
                  <ButtonGroup>
                    <Button
                      color={mode === 'muscle' ? 'primary' : 'secondary'}
                      size="sm"
                      onClick={() => setMode('muscle')}
                      active={mode === 'muscle'}
                    >
                      Muscle to details
                    </Button>
                    <Button
                      color={mode === 'nerve' ? 'primary' : 'secondary'}
                      size="sm"
                      onClick={() => setMode('nerve')}
                      active={mode === 'nerve'}
                    >
                      Nerve to muscles
                    </Button>
                  </ButtonGroup>
                </Col>

                {mode === 'muscle' && (
                  <Col xs="12" lg="auto" className="mb-2 mb-lg-0">
                    <div className="d-flex align-items-center flex-wrap" style={{ gap: '12px' }}>
                      <small className="text-uppercase text-muted font-weight-bold" style={{ letterSpacing: '.05em' }}>
                        Test
                      </small>
                      <CustomInput
                        type="checkbox"
                        id="toggle-nerve"
                        label="Nerve"
                        checked={showNerve}
                        onChange={e => setShowNerve(e.target.checked)}
                        inline
                      />
                      <CustomInput
                        type="checkbox"
                        id="toggle-root"
                        label="Root"
                        checked={showRoot}
                        onChange={e => setShowRoot(e.target.checked)}
                        inline
                      />
                      <CustomInput
                        type="checkbox"
                        id="toggle-fn"
                        label="Function"
                        checked={showFn}
                        onChange={e => setShowFn(e.target.checked)}
                        inline
                      />
                    </div>
                  </Col>
                )}

                <Col xs="12" lg="auto" className="ml-lg-auto">
                  <ButtonGroup>
                    <Button color="primary" size="sm" onClick={handleCheckAll}>
                      <i className="fas fa-check mr-1" /> Check All
                    </Button>
                    <Button color="default" size="sm" outline onClick={handleRevealAll}>
                      <i className="fas fa-eye mr-1" /> Show Answers
                    </Button>
                    <Button color="default" size="sm" outline onClick={handleReset}>
                      <i className="fas fa-redo mr-1" /> Reset
                    </Button>
                    <Button color="default" size="sm" outline onClick={handlePrint}>
                      <i className="fas fa-print mr-1" /> Print
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <div className="muscle-drill-container">
                <Scoreboard
                  mode={mode}
                  muscleScore={muscleScore}
                  nerveScore={nerveScore}
                />

                <div style={{ display: mode === 'muscle' ? 'block' : 'none' }}>
                  <MuscleMode
                    ref={muscleModeRef}
                    showNerve={showNerve}
                    showRoot={showRoot}
                    showFn={showFn}
                    onScoreChange={handleMuscleScoreChange}
                  />
                </div>
                <div style={{ display: mode === 'nerve' ? 'block' : 'none' }}>
                  <NerveMode
                    ref={nerveModeRef}
                    onScoreChange={handleNerveScoreChange}
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </AccessRestriction>
    </>
  );
};

export default MuscleInnervationDrills;
